import clsx from 'clsx';
import type { MapFilters } from './mapUtils';

const LAYER_FILTERS: { key: keyof MapFilters; label: string; color: string }[] = [
  { key: 'showSOS', label: 'SOS Events', color: 'bg-red-500' },
  { key: 'showGeofences', label: 'Geofences', color: 'bg-cyan-500' },
  { key: 'showFarmbases', label: 'Farmbases', color: 'bg-teal-400' },
  { key: 'showTargets', label: 'Targets', color: 'bg-rose-500' },
  { key: 'showTrails', label: 'Movement Trails', color: 'bg-blue-500' },
];

/**
 * Map layer/platoon visibility checkboxes. Rendered in the desktop
 * filter dropdown or the mobile "Filters" bottom sheet. Rows are 44px+
 * for touch.
 */
export default function MapFilterPanel({
  filters,
  onChange,
}: {
  filters: MapFilters;
  onChange: (next: MapFilters) => void;
}) {
  const row = (checked: boolean, toggle: () => void, dot: string, label: string) => (
    <label
      key={label}
      className="flex items-center gap-3 cursor-pointer min-h-11 touch-manipulation"
    >
      <input
        type="checkbox"
        checked={checked}
        onChange={toggle}
        className="w-5 h-5 lg:w-4 lg:h-4 rounded border-gray-600 text-blue-500 focus:ring-blue-500"
      />
      <div className={clsx('w-3 h-3 rounded-full', dot)} />
      <span className="text-sm text-gray-300">{label}</span>
    </label>
  );

  return (
    <div className="space-y-1">
      <div>
        <div className="text-xs font-bold text-gray-400 mb-1 uppercase tracking-wide">Platoons</div>
        <div className="pl-2">
          {row(filters.showOnline, () => onChange({ ...filters, showOnline: !filters.showOnline }), 'bg-green-500', 'Online')}
          {row(filters.showOffline, () => onChange({ ...filters, showOffline: !filters.showOffline }), 'bg-gray-500', 'Offline')}
        </div>
      </div>

      <div className="border-t border-gray-700 my-1" />

      {LAYER_FILTERS.map((f) => (
        <div key={f.key}>
          {row(filters[f.key], () => onChange({ ...filters, [f.key]: !filters[f.key] }), f.color, f.label)}
          {/* "Show inactive" sub-toggle nests under Targets (F-2). */}
          {f.key === 'showTargets' && filters.showTargets && (
            <div className="pl-6">
              {row(
                filters.showInactiveTargets,
                () => onChange({ ...filters, showInactiveTargets: !filters.showInactiveTargets }),
                'bg-gray-500',
                'Ended targets'
              )}
            </div>
          )}
        </div>
      ))}
    </div>
  );
}
